import React, {Component} from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export default class BreadcrumbComponent extends Component {

    constructor (props) {

        super(props);
        this.state = {

        };

    }

    render () {

        return (
            <>
                {this.props.crumbs !== undefined
                    ? <Breadcrumb>
                        {
                            this.props.crumbs.map((crumb, index, crumbs) => {
                                if (crumb.text === "CrossHairs" || crumb.text === "CrossHairs Dashboard") {
                                   return <Breadcrumb.Item key={crumb.key}
                                        onClick={(e) => crumb.clickEvent(e)}>
                                        {crumb.text ? crumb.text : crumb.crumbText}
                                    </Breadcrumb.Item>;
                                }
                                else {
                                   if (index === crumbs.length - 1) {
                                        return <Breadcrumb.Item active key={crumb.key}>
                                            {crumb.text ? crumb.text : crumb.crumbText}
                                        </Breadcrumb.Item>;
                                    }
                                    return <Breadcrumb.Item key={crumb.key}
                                        onClick={(e) => crumb.clickEvent(e)}>
                                        {crumb.text ? crumb.text : crumb.crumbText}
                                    </Breadcrumb.Item>;
                                }
                            })
                        }
                      </Breadcrumb>
                    : <></>}
            </>
        );

    }

}
